import React, { useCallback, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import IE from "../../../components/Formatters/IE";
import CNPJ from "../../../components/Formatters/CNPJ";
import CPF from "../../../components/Formatters/CPF";

const descricaoCell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const columns = [
  {
    name: "IE",
    cell: (row) => <IE value={row.ie} />,
    width: "170px",
  },
  {
    name: "CNPJ/CPF",
    cell: (row) => (row.cpfCnpj.length === 11 ? <CPF value={row.cpfCnpj} /> : <CNPJ value={row.cpfCnpj} />),
    width: "190px",
  },
  {
    name: "Razão Social",
    selector: (row) => row.nome,
    width: "30%",
  },
  {
    name: "Situação IE",
    selector: (row) => row.stContribuinte,
    width: "140px",
  },
  {
    name: "Endereço",
    cell: (row) => row.endereco,
    // width: "10%",
  },
  {
    name: "Domicílio Tributário",
    selector: (row) => row.domicilioTributario,
    cell: (row) => descricaoCell(row.domicilioTributario),
    // width: "20%",
  },
];

const TableContribuinteParteServico = ({ formik, field, data }) => {
  const setPageSize = useState(25)[1];
  const setPageNumber = useState(1)[1];

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  const handlePerRowsChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      setPageNumber(1);
    },
    [setPageSize, setPageNumber],
  );

  const rowSelectCritera = useCallback((row) => row.ie, []);

  return (
    <DataTable
      title="Lista de Contribuintes"
      fixedHeader
      noHeader
      columns={columns}
      data={data}
      noDataComponent=""
      onSelectedRowsChange={(item) => formik.setFieldValue(field, item.selectedRows)}
      selectableRowSelected={rowSelectCritera}
      sortable
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
    />
  );
};

export default TableContribuinteParteServico;
